import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticClass:"secondary",attrs:{"outlined":""},on:{"click":_vm.confirmAbandon}},[_c('i',{staticClass:"fa-regular fa-running"}),_vm._v(" "+_vm._s(_vm.$t("btnText"))+" "),_c(VSnackbar,{attrs:{"color":"#C42A14"},model:{value:(_vm.showMsg),callback:function ($$v) {_vm.showMsg=$$v},expression:"showMsg"}},[_vm._v(" "+_vm._s(_vm.$t("errorAbandoned"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }